import React from 'react';
import classNames from 'classnames';
import unorderedStyles from '../unordered/unordered.module.scss';
import styles from './item.module.scss';

type LIProps = {
  children: React.ReactNode;
  variant: 'ordered' | 'unordered';
};

const LI: React.FC<LIProps> = ({ children, variant }) => {
  return (
    <li className={classNames(styles.root, { [unorderedStyles.listItem]: variant === 'unordered' })}>{children}</li>
  );
};

type OLIProps = {
  children: React.ReactNode;
};

export const OLI: React.FC<OLIProps> = ({ children }) => {
  return <LI variant="ordered">{children}</LI>;
};

type ULIProps = {
  children: React.ReactNode;
};

export const ULI: React.FC<ULIProps> = ({ children }) => {
  return <LI variant="unordered">{children}</LI>;
};
